module.exports = __webpack_public_path__ + "img/the_bay.e68cecdd.jpg";